import type { ZudokuConfig } from "zudoku";
import { apis, navigation, site, theme } from "./zudoku-config";
import { NibssApiNav } from "./src/components/NibssApiNav";

const { footer } = site

const config: ZudokuConfig = {
  metadata: {
    title: "CBN Developer Portal",
    favicon: "/cbn-logo.png",
  },
  site: {
    logo: {
      src: { light: "/cbn-logo-light.svg", dark: "/cbn-logo-dark.svg" },
      alt: "Central Bank of Nigeria",
      width: "160px",
    },
    showPoweredBy: false,
    footer
  },
  docs: {
    defaultOptions: {
      showLastModified: false
    }
  },
  slots: {
    "content-before": NibssApiNav,
  },
  theme,
  navigation,
  apis
};

export default config;
